import { NgIf, NgFor, Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faAngleLeft, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { ReportsService } from '@main/reports/reports.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PaymentService } from '../../../payment.service';

@Component({
  selector: 'app-paid',
  imports: [NgbTooltip, FaIconComponent, NgIf, NgFor, ReactiveFormsModule],
  templateUrl: './paid.component.html',
  styleUrl: './paid.component.css',
  standalone: true,
})
export class PaidComponent implements OnInit {
  private reportService = inject(ReportsService);
  private paymentService = inject(PaymentService);
  location = inject(Location);

  selectedYear: number = new Date().getFullYear();
  faAngleLeft = faAngleLeft;
  faFileDownload = faFileDownload;
  years: number[] = [];

  ngOnInit(): void {
    this.getDistinctPaymentDateYears();
    
  }

  private getDistinctPaymentDateYears(): void {
    this.paymentService.getDistinctPaymentDateYears().subscribe((years) => {
      this.years = years;
      if (this.years.length > 0) {
       this.fetchSalesTaxPaid();
      }
    });
  }


  fetchSalesTaxPaid(): void {
    this.reportService
      .getSalesTaxPaidByYear(this.selectedYear)
      .subscribe((data) => {
        console.log('Sales Tax Paid Data:', data);
        // Handle the received data as needed
      });
  }

  exportReport(): void {
    this.reportService.exportSalesTaxPaidByYear(this.selectedYear);
  }

  yearSelected(event: any) {
    this.selectedYear = event.target.value;
  }
}
